import { useState, useEffect, useRef } from 'react'
import { useLang } from '../utils/hooks'
import { langLogin } from '../assets/langLogin'

const CreatePwd = ({ doSubscribe, onConfirmPwd, onCancel, title }) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langLogin.fr : langLogin.eng
  const [pwd, setPwd] = useState('')
  const [validPwd, setValidPwd] = useState(false)
  const [secondPwd, setSecondPwd] = useState('')
  const [validSecondPwd, setValidSecondPwd] = useState(false)
  const [samePwd, setSamePwd] = useState(false)

  const first = useRef(null)
  useEffect(() => {
    if (!first.current) return
    first.current.focus()
  }, [])

  useEffect(() => {
    if (pwd.length > 0 && secondPwd.length > 0) {
      setSamePwd(pwd === secondPwd)
    } else {
      setSamePwd(false)
    }
  }, [pwd, secondPwd])

  const onPwdChange = (e) => {
    setPwd(e.target.value)
    setValidPwd(e.target.value.length > 5 && e.target.value.length < 21)
  }

  const onSecondPwdChange = (e) => {
    setSecondPwd(e.target.value)
    setValidSecondPwd(e.target.value.length > 5 && e.target.value.length < 21)
  }
  return (
    <>
      <div className="field">
        <label className="label">{title}</label>
        <div className="control has-icons-left has-icons-right">
          <input
            className={'input ' + (validPwd ? 'is-primary' : 'is-danger')}
            type="password"
            placeholder={choosenLang.pwd}
            value={pwd}
            onChange={onPwdChange}
            ref={first}
          />
          <span className="icon is-small is-left">
            <i className="fa fas fa-lock"></i>
          </span>
          {!validPwd && (
            <span className="icon is-small is-right">
              <i className="fa fa-exclamation-triangle"></i>
            </span>
          )}
        </div>
        <p className="help is-danger">
          {validPwd
            ? ''
            : pwd.length > 0
            ? choosenLang.alertPwdNoMatch
            : choosenLang.alertPwd}
        </p>
      </div>
      <div className="field">
        <div className="control has-icons-left has-icons-right">
          <input
            className={'input ' + (validSecondPwd ? 'is-primary' : 'is-danger')}
            type="password"
            placeholder={choosenLang.pwdConfirm}
            value={secondPwd}
            onChange={onSecondPwdChange}
          />
          <span className="icon is-small is-left">
            <i className="fa fas fa-lock"></i>
          </span>
          {!validSecondPwd && (
            <span className="icon is-small is-right">
              <i className="fa fa-exclamation-triangle"></i>
            </span>
          )}
        </div>
        <p className="help is-danger">
          {validSecondPwd
            ? ''
            : secondPwd.length > 0
            ? choosenLang.alertPwd
            : ''}
        </p>
        <p className="help is-danger">
          {samePwd ? '' : choosenLang.alertPwdNoMatch}
        </p>
        <div className="field is-grouped">
          <p className="control">
            <button
              className={'button ' + (doSubscribe ? 'is-info ' : 'is-primary')}
              onClick={() => onConfirmPwd(pwd)}
              disabled={!samePwd}
            >
              {choosenLang.continue}
            </button>{' '}
          </p>
          <p className="control">
            <button className="button is-light " onClick={onCancel}>
              {choosenLang.cancel}
            </button>
          </p>
        </div>
      </div>
    </>
  )
}
export default CreatePwd
